import React from 'react';
import { PriceBlock } from '@hpstellar/core';
import { PriceBlockUs } from '@hpstellar/core/visId';

import { useGetProductPrice } from '../../../hooks/useProductPrice';

export default ({ product, priceBlockProps = {}, visid }) => {
    const price = useGetProductPrice(product, { transformPriceProps: true });

    if (visid) {
        const oldPrice = price?.regularPrice !== price?.salePrice ? `$${price?.regularPrice}` : null;
        const finalPrice = `$${price?.salePrice}`;
        const saveLabel = price?.customSaleText && <span className="priceDifference-gfe">{price?.customSaleText}</span>;

        return (
            <div className="price-container">
                {price && (
                    <PriceBlockUs
                        finalPriceTypographyVariant="subtitle"
                        {...price}
                        saveLabel={saveLabel}
                        oldPrice={oldPrice}
                        finalPrice={finalPrice}
                    />
                )}
            </div>
        );
    }
    return <div className="price-container">{price && <PriceBlock {...price} {...priceBlockProps} />}</div>;
};
